import { render, staticRenderFns } from "./LogoGOV.vue?vue&type=template&id=0e578e63"
import script from "./LogoGOV.vue?vue&type=script&lang=js"
export * from "./LogoGOV.vue?vue&type=script&lang=js"
import style0 from "./LogoGOV.vue?vue&type=style&index=0&id=0e578e63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports